import { useEffect, useState } from "react";
import { fetchData } from "../../api";
import { useLocation } from "react-router-dom";

export default function Banner() {
  const [homeBanner, setHomeBanner] = useState(null);
  const [animate, setAnimate] = useState(false);
  const location = useLocation();

  useEffect(() => {
    fetchData("home-banners", true).then((data) => setHomeBanner(data?.[0]));
  }, []);

  useEffect(() => {
    setAnimate(true);
    const timeout = setTimeout(() => setAnimate(false), 3000);
    return () => clearTimeout(timeout);
  }, [location.pathname]);

  if (!homeBanner) return null;

  return (
    <main className="relative before:bg-[#000]/50 before:backdrop-blur-[0px] before:absolute before:left-0 before:top-0 before:w-full before:h-full max-sm:h-[360px] ">
      <img
        className="w-full h-full object-cover lg:max-h-[800px]"
        src={`${process.env.NEXT_PUBLIC_STRAPI_URL || "https://api.bouwbedrijfgeluk.nl"}${homeBanner.bannerBg?.url }`}
        alt="bg"
      />
      <div className="max-w-2xl space-y-6 text-center absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 max-lg:max-w-lg max-md:left-1/2 max-md:-translate-x-1/2 max-md:text-center max-sm:w-full max-sm:top-2/3">
        <h1 className={`text-[80px] font-semibold text-white capitalize max-lg:text-[48px] max-md:text-[28px] max-sm:text-[26px]`}>{homeBanner?.title}</h1>
        <p className="text-white">{homeBanner?.subtitle}</p>
        <a href="/contact" className="relative bg-[#27352C] w-[170px] h-[58px] text-white px-3 flex mx-auto items-center justify-center max-md:mx-auto rounded-[0_0_24px_0]">
          Aan de slag
          {/* <span className=" absolute  w-[40px] h-[58px] bg-[#286766] flex items-center justify-center -right-2 skew-x- rounded-[0_12px_40px_0]"></span> */}
        </a>
      </div>
    </main>
  );
}
